/*
 * CMP-018 Current-look panel — Phase A1. No dependencies. The panel reports intent and the host (gateway) decides.
 *   remove x   -> `nc-look:remove` {id} (cancelable). If not prevented the row is removed at once (optimistic), the count
 *                 updates, focus moves to the next row's remove button (else previous, else the save button, else the panel)
 *                 and, with no rows left, the empty state replaces the list. NcCurrentLook.restoreItem puts it back on failure.
 *   Guardar look -> `nc-look:save` (the host sets the button to loading with data-state, or calls setStatus 'pending').
 *   heart      -> `nc-look:favorite` {pressed}; retry -> `nc-look:retry`.
 * NcCurrentLook.setStatus(root, 'populated'|'empty'|'pending'|'error') switches the visible block; the panel never goes blank.
 */
(function () {
  // count text for the header; kept pure so the format "(n)" is tested
  function countText(n) { return '(' + Math.max(0, n) + ')'; }

  if (typeof module !== 'undefined' && module.exports) module.exports = { countText: countText };
  if (typeof customElements === 'undefined' || customElements.get('nc-current-look')) return;

  class NcCurrentLookElement extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this.onClick.bind(this));
    }

    get rows() { return Array.prototype.slice.call(this.querySelectorAll('.nc-current-look__item')); }

    updateCount() {
      var out = this.querySelector('[data-nc-look-count]');
      if (out) out.textContent = countText(this.rows.length);
    }

    setStatus(status) {
      this.setAttribute('data-status', status);
      var empty = status === 'empty';
      var error = status === 'error';
      this.querySelector('.nc-current-look__state--empty').hidden = !empty;
      this.querySelector('.nc-current-look__state--error').hidden = !error;
      this.querySelector('.nc-current-look__save').hidden = empty || error;
      this.querySelector('.nc-current-look__items').hidden = empty || error;
      var save = this.querySelector('.nc-current-look__save .nc-button');
      if (save) {
        save.setAttribute('data-state', status === 'pending' ? 'loading' : 'default');
        if (status === 'pending') { save.setAttribute('aria-busy', 'true'); save.setAttribute('aria-disabled', 'true'); }
        else { save.removeAttribute('aria-busy'); save.removeAttribute('aria-disabled'); }
      }
      // the count would contradict the error/empty block, so it is hidden there
      var count = this.querySelector('[data-nc-look-count]');
      if (count) count.hidden = empty || error;
      this.setAttribute('aria-busy', status === 'pending' ? 'true' : 'false');
      var live = this.querySelector('[data-nc-look-status]');
      if (live) live.textContent = status === 'pending' ? (this.getAttribute('data-msg-saving') || '') : '';
    }

    removeRow(row) {
      var rows = this.rows;
      var i = rows.indexOf(row);
      var next = rows[i + 1] || rows[i - 1];
      row.remove();
      this.updateCount();
      if (!this.rows.length) {
        this.setStatus('empty');
        this.setAttribute('tabindex', '-1');
        this.focus();
        return;
      }
      if (next) next.querySelector('.nc-current-look__remove').focus();
    }

    onClick(event) {
      var remove = event.target.closest('.nc-current-look__remove');
      if (remove) {
        var row = remove.closest('.nc-current-look__item');
        var ok = this.dispatchEvent(new CustomEvent('nc-look:remove', { bubbles: true, cancelable: true, detail: { id: row.getAttribute('data-id') } }));
        if (ok) this.removeRow(row);
        return;
      }
      if (event.target.closest('.nc-current-look__save .nc-button')) {
        this.dispatchEvent(new CustomEvent('nc-look:save', { bubbles: true }));
        return;
      }
      var fav = event.target.closest('.nc-current-look__header .nc-icon-button');
      if (fav) {
        var pressed = fav.getAttribute('aria-pressed') !== 'true';
        fav.setAttribute('aria-pressed', pressed ? 'true' : 'false');
        this.dispatchEvent(new CustomEvent('nc-look:favorite', { bubbles: true, detail: { pressed: pressed } }));
        return;
      }
      if (event.target.closest('[data-nc-retry]')) this.dispatchEvent(new CustomEvent('nc-look:retry', { bubbles: true }));
    }
  }

  customElements.define('nc-current-look', NcCurrentLookElement);

  window.NcCurrentLook = {
    setStatus: function (root, status) { root.setStatus(status); },
    removeItem: function (root, id) {
      var row = root.querySelector('.nc-current-look__item[data-id="' + id + '"]');
      if (row) root.removeRow(row);
    }
  };
})();
